import {APIConnector} from "./api/APIConnector";
import {ListQuery} from "../models/ListQuery";
import {Translator} from "../contexts/translator";
import {ListData} from "../models/ListData";
import {getConstraintViolation, processServerError} from "./utilities/ServiceError";
import {createPartialURL, getFilterClause} from "./utilities/urlBuilder";
import {createPagination} from "./utilities/paginationBuilder";
import {Deserializer} from "jsonapi-serializer";
import {genericError} from "../models/GenericError";
import {getDateTimeWithoutMillis} from "../utilities/DateUtils";
import {CertificateAudit} from "../models/CertificateAudit";

const apiConnector = new APIConnector();
/*
Certificate audit records for a specific controller.
E.g. certificate operations like upload, generate, import, export, delete, etc.
*/
export const getCertificateAudit = async (controller:string, listParameters?: ListQuery, translate?: Translator):Promise<ListData> => {
    try{
        const filter: string = getFilterClause(listParameters?.filters, listParameters?.searchTerm);
        const partialURL = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filter);
        const url = `auditControllerCertificate?${partialURL}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const pagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if(json.errors){
                return reject({ status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }
            new Deserializer().deserialize(json, (err: any, records: any[]) => {
                if (err) {
                    return reject({ status: response.status, message: genericError })
                }

                const auditRecords: CertificateAudit[] = records.map((certificateAudit) => buildCertificateAudit(certificateAudit, translate));
                return resolve({ rows: auditRecords, pagination });
            })
        })
    }catch (error){
        return new Promise((resolve, reject) => {
            reject(processServerError(error))
        })
    }
}

/*
  Build the audit record for certificate operations.
*/
const buildCertificateAudit: (value: any, translate) => CertificateAudit = (apiCertificateAudit, translate?: Translator): CertificateAudit => {
    return {
        id: apiCertificateAudit['id'],
        name: 'Certificate',
        dateTime: getDateTimeWithoutMillis(apiCertificateAudit['date-time-local']),
        operator: apiCertificateAudit['operator'],
        action: apiCertificateAudit['action'],
        valueOld: apiCertificateAudit['old-cert'] || '',
        valueNew: apiCertificateAudit['new-cert'] || ''
    };
};
